import React from "react";
import { Routes, Route, useNavigate, useLocation, useParams } from "react-router-dom";
import { StatesLoadingDialog } from "./states-loading-dialog/StatesLoadingDialog";
import { StateDeleteDialog } from "./state-delete-dialog/StateDeleteDialog";
import { StatesDeleteDialog } from "./states-delete-dialog/StatesDeleteDialog";
import { StatesFetchDialog } from "./states-fetch-dialog/StatesFetchDialog";
import { StatesUpdateStatusDialog } from "./states-update-status-dialog/StatesUpdateStatusDialog";
import { StatesCard } from "./StatesCard";
import { StatesUIProvider } from "./StatesUIContext";

function StatesDeleteDialogRoute() {
  const location = useLocation();
  const navigate = useNavigate();
  return <StatesDeleteDialog show={location.pathname === "/location/states/deleteStates"} onHide={() => navigate("/location/states")} />;
}
function StateDeleteDialogRoute() {
  const navigate = useNavigate();
  const { id } = useParams();
  return <StateDeleteDialog show id={id} onHide={() => navigate("/location/states")} />;
}
function StatesFetchDialogRoute() {
  const location = useLocation();
  const navigate = useNavigate();
  return <StatesFetchDialog show={location.pathname === "/location/states/fetch"} onHide={() => navigate("/location/states")} />;
}
function StatesUpdateStatusDialogRoute() {
  const location = useLocation();
  const navigate = useNavigate();
  return <StatesUpdateStatusDialog show={location.pathname === "/location/states/updateStatus"} onHide={() => navigate("/location/states")} />;
}

export function StatesPage() {
  const navigate = useNavigate();
  const statesUIEvents = {
    newStateButtonClick: () => navigate("/location/states/new"),
    openEditStatePage: (id) => navigate(`/location/states/${id}/edit`),
    openDeleteStateDialog: (id) => navigate(`/location/states/${id}/delete`),
    openDeleteStatesDialog: () => navigate("/location/states/deleteStates"),
    openFetchStatesDialog: () => navigate("/location/states/fetch"),
    openUpdateStatesStatusDialog: () => navigate("/location/states/updateStatus"),
  };

  return (
    <StatesUIProvider statesUIEvents={statesUIEvents}>
      <StatesLoadingDialog />
      <Routes>
        <Route path="deleteStates" element={<StatesDeleteDialogRoute />} />
        <Route path=":id/delete" element={<StateDeleteDialogRoute />} />
        <Route path="fetch" element={<StatesFetchDialogRoute />} />
        <Route path="updateStatus" element={<StatesUpdateStatusDialogRoute />} />
      </Routes>
      <StatesCard />
    </StatesUIProvider>
  );
}
